const SaveSmallIcon = () => {
    return (
        <svg width="19px" height="18px" viewBox="0 0 19 18" version="1.1" xmlns="http://www.w3.org/2000/svg" >
            <title>Stroke 91</title>
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopChatThreadJobBoard1920Copy7" transform="translate(-451, -835)" stroke="#6C7275" strokeWidth="2">
                    <g id="Group18" transform="translate(452, 831)">
                        <g id="Stroke91" transform="translate(0, 6)">
                            <path d="M7.48874329,14.6451936 C8.08084142,15.1182688 8.91915858,15.1182688 9.51125671,14.6451936 C11.764077,12.8439973 17,8.27205135 17,4.68470362 C17,0.330907172 12.2607025,-1.56473697 9.73737623,1.51443103 C9.10256663,2.29007378 7.89743337,2.29007378 7.26262377,1.51443103 C4.7392975,-1.56473697 0,0.330907172 0,4.68470362 C0,8.27205135 5.23592295,12.8439973 7.48874329,14.6451936 Z" id="Stroke90"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default SaveSmallIcon;
